import { useCallback, useEffect, useRef, useState } from 'react';

export default function useChoices(fetchItems) {
  const [data, setData] = useState({ items: null, error: false });
  const generation = useRef(0);
  const load = useCallback(async () => {
    const request = ++generation.current;
    setData(current => ({ ...current, error: false }));
    try {
      const items = await fetchItems();
      if (!Array.isArray(items)) throw new Error('Invalid choices');
      if (generation.current === request) setData({ items, error: false });
    } catch (error) {
      if (generation.current === request) setData(current => ({ ...current, error: true }));
    }
  }, [fetchItems]);
  useEffect(() => { load(); return () => { ++generation.current; }; }, [load]);
  const saved = item => {
    ++generation.current;
    setData(current => ({ error: false, items: [...(current.items || []).filter(old => String(old.id) !== String(item.id)), item] }));
  };
  const removed = id => {
    ++generation.current;
    setData(current => ({ ...current, items: (current.items || []).filter(item => String(item.id) !== String(id)) }));
  };
  return { ...data, load, saved, removed };
}
